[
  {"id":"chip_kedu","text":"Kedu?","gloss":"How are you?","igbo":true},
  {"id":"chip_nna_eh","text":"Nna eh!","gloss":"Wow! (surprise or sympathy)","igbo":true},
  {"id":"chip_chai","text":"Chai!","gloss":"Oh dear! (shock, pity or delight)","igbo":false},
  {"id":"chip_o_di_mma","text":"Ọ dị mma","gloss":"It is fine / okay","igbo":true},
  {"id":"chip_ehen","text":"Ehen!","gloss":"Aha! Now we are talking.","igbo":false},
  {"id":"chip_gbam","text":"Gbam!","gloss":"Exactly! Spot on!","igbo":false},
  {"id":"chip_i_dey_come","text":"I dey come","gloss":"I am on my way / back soon","igbo":false},
  {"id":"chip_daalu","text":"Daalụ","gloss":"Thank you","igbo":true},
  {"id":"chip_ndo","text":"Ndo","gloss":"Sorry (sympathy)","igbo":true},
  {"id":"chip_light_gone","text":"Light don go!","gloss":"Power cut again.","igbo":false},
  {"id":"chip_abeg","text":"Abeg","gloss":"Please","igbo":false},
  {"id":"chip_oya","text":"Oya, make we go","gloss":"Come on, let's go","igbo":false}
]
